export default __webpack_public_path__ + "static/media/star-no.6c5ec944.svg";